// Accessible tab component from https://inclusive-components.design/tabbed-interfaces/
// This component functions on:
// template-news-events-listing.blade.php
// template-tabbed.blade.php

export default class Tabs {
  constructor(el) {
    // Get relevant elements and collections
    // const tabbed = el;
    // const form = document.getElementById('TabbedTemplate-mobileSelect');
    const selectMenu = el.querySelector('.TabbedTemplate-mobileSelect-select');
    const sections = document.querySelectorAll('.TabbedTemplate-mobileSection');

    // Add classes on page load.
    sections.forEach(section => {
      if(section.id === selectMenu.value) {
        section.classList.add('visible');
        section.classList.remove('hidden');
      } else {
        section.classList.remove('visible');
          section.classList.add('hidden');
      }
    });

    // Update menu on change
    selectMenu.addEventListener('change', (event) => {
      sections.forEach(item =>{
        if(item.id === event.target.value ){
          // console.log(event.target);
          item.classList.add('visible');
          item.classList.remove('hidden');
        } else {
          item.classList.remove('visible');
          item.classList.add('hidden');
        }
      });
    });
  }
}

const init = () => {
  let el = document.querySelector(".TabbedTemplate-mobileSelect");

  if (el) {
    new Tabs(el);
  }
};

// Init on initial page load
init();
